<div class="main-content">
  <div class="first-row">
    <div class="title-row" *ngIf="environment !== 'camera-stock'">
      <span class="modal-title">
        {{environment === 'kit-list' ? 'Excluir câmeras e analíticos do estoque do Parceiro' : 'Editar estoque do parceiro'}}
      </span>
      <span class="modal-title name">{{partnerName}}</span>
    </div>
    <div class="title-row" *ngIf="environment === 'camera-stock'">
      <span class="modal-title">Solicitar estoque</span>
    </div>
    <div (click)="closeModal()" class="close-modal">
        <span nz-icon nzType="close" nzTheme="outline"></span>
    </div>
  </div>
  <div class="scroll-modal">
    <span class="description" *ngIf="environment === 'kit-list'">
      Essa ação removerá as câmeras e analíticos disponíveis do Kit selecionado para o Parceiro, mas manterá as câmeras e analíticos já distribuídas.
    </span>
    <span class="description" *ngIf="environment !== 'kit-list'">
      {{environment === 'camera-stock' ? 'Selecione os itens e a quantidade para serem solicitados' : 'Selecione os itens e a quantidade para serem alterados do estoque do parceiro'}}
    </span>
    <form [formGroup]="editForm" class="form-container" *ngIf="environment === 'kit-list'">
      <div style="display: flex;">
        <div class="container-input-select">
          <div class="deleting-kit">
            <span class="camera-info"><b>Analíticos</b></span>
          </div>
        </div>
        <div class="container-input-select-two">
          <div class="label-input" style="margin-left: 20px;">
            <span>Selecione a quantidade</span>
          </div>
          <div class="info-line">
            <nz-input-number class="input-container-number" formControlName="detectionsAmount" (change)="checkLimit()" [nzMin]="1" [nzMax]="qtdAnalytic" [nzStep]="1"></nz-input-number>
          </div>
          <mat-error style="position: relative; bottom: 16%; left: 8%;" *ngIf="editForm.get('detectionsAmount').hasError('required') && editForm.get('detectionsAmount').touched">
            *Campo obrigatório
          </mat-error>
        </div>
      </div>
      <div style="display: flex;">
        <div class="container-input-select">
          <div class="deleting-kit">
            <span class="camera-info"><b>CÂMERA {{camResolution}}</b> {{camDays}} {{camDays == 1 ? ' dia' : ' dias'}}</span>
          </div>
        </div>
        <div class="container-input-select-two">
          <div class="label-input" style="margin-left: 20px;">
            <span>Selecione a quantidade</span>
          </div>
          <div class="info-line">
            <nz-input-number class="input-container-number" formControlName="planAmount" (change)="checkLimit()" [nzMin]="1" [nzMax]="qtdCam" [nzStep]="1"></nz-input-number>
          </div>
          <mat-error style="position: relative; bottom: 16%; left: 8%;" *ngIf="editForm.get('planAmount').hasError('required') && editForm.get('planAmount').touched">
            *Campo obrigatório
          </mat-error>
        </div>
      </div>
      <span class="final-warning"><span style="margin-right: 5px; color: #306EBF;" nz-icon nzType="warning" nzTheme="outline"></span>Ao alterar a quantidade do estoque outros kits poderão ser afetados</span>
    </form>

    <div class="form-container" *ngIf="environment !== 'kit-list'">
      <div *ngIf="true" style="margin-left: -13px;">
        <nz-table #basicTable [nzData]="elementsKit" [nzShowPagination]="false" class="style-table" [nzSize]="'small'">
          <tbody>
            <tr>
              <td style="width: 445px;"></td>
              <td class="table-subtitle">Selecione a quantidade</td>
            </tr>
            <tr>
              <td class="table-title">Detecções inteligentes</td>
              <td>
                <!-- Primeiro input -->
                <div style="width: 320px;">
                  <nz-input-number
                    class="label-container"
                    nzPlaceHolder="Quantidade de detecções"
                    [nzMin]="analyticMin"
                    [ngModel]="analyticTotalDisplay"
                    [nzStep]="1"
                    (ngModelChange)="setAnalyticTotal($event)">
                  </nz-input-number>
                </div>
                <mat-error
                  style="position: relative; bottom: 16%"
                  *ngIf="(analyticTotalDisplay == null && data.amount > 0) && errorPass">
                  *Campo obrigatório
                </mat-error>
              </td>
            </tr>
            <tr>
              <td class="table-subtitle">Plano</td>
              <td class="table-subtitle">Selecione a quantidade</td>
            </tr>
          <tr *ngFor="let data of basicTable.data; let i = index">
            <td>
              <!-- select de plano -->
              <div class="name_type">
                <app-filter type="multiweight" [list]="optionsPlan" placeholder="Selecionar o plano" [ngModel]="data.plan" [selected]="data.plan"
                      (filterStatusChange)="changePlan($event, i)" [showSelected]="true" [hideHover]="true" [hideActiveFill]="true">
                </app-filter>
                <mat-error style="position: relative; bottom: 16%" *ngIf="data.plan === '' && errorPass">
                  *Campo obrigatório
                </mat-error>
              </div>
            </td>
            <td>
              <!-- Segundo input -->
              <div style="width: 320px;">
                <nz-input-number class="label-container inputNumberCustom" [ngModel]="data.amount" [nzMin]="environment === 'camera-stock' ? 1 : 0" nzPlaceHolder="Quantidade de câmeras"
                (ngModelChange)="getPlanAmount($event, i)"></nz-input-number>
                <span *ngIf="elementsKit.length > 1" nz-icon class="close-button" nzType="close" nzTheme="outline" (click)="removeKit(i)"></span>
              </div>
              <mat-error style="position: relative; bottom: 16%" *ngIf="data.amount === '' && errorPass">
                *Campo obrigatório
              </mat-error> 
            </td>
          </tr>
          </tbody>
        </nz-table>
        <button (click)="newKits()" type="button" class="add-button" [hidden]="elementsKit.length === plans.length">
          <span nz-icon nzType="plus" style="margin-right: 8px;" nzTheme="outline"></span>
          Adicionar outro plano
        </button>
      </div>
    </div>
  </div>
  <div class="final-row">
    <button (click)="closeModal()" class="button-row cancel">Cancelar</button>
    <button *ngIf="environment === 'kit-list'"
            [class.button-disabled]="(editForm.get('planAmount').hasError('required') && editForm.get('planAmount').touched)
            || (editForm.get('detectionsAmount').hasError('required') && editForm.get('detectionsAmount').touched) || loading"
            (click)="deleteKit()" class="button-row delete">
            Excluir <span style="margin-left: 5px;" *ngIf="loading" nz-icon nzType="loading" nzTheme="outline"></span>
    </button>
    <button *ngIf="environment === 'camera-stock'"
            [class.button-disabled]="loading && !errorPass"
            (click)="requestKit()"
            class="button-row delete">
            Solicitar <span *ngIf="loading" style="margin-left: 5px;" nz-icon nzType="loading" nzTheme="outline"></span>
    </button>
    <button *ngIf="environment === 'detections-stock'"
            [class.button-disabled]="loading && !errorPass"
            (click)="updateKit()" class="button-row delete">
            Salvar <span style="margin-left: 5px;" *ngIf="loading" nz-icon nzType="loading" nzTheme="outline"></span>
    </button>
  </div>
</div>
